import { Fragment } from 'react';
import styles from './DataSource.module.scss';
import Button from '../Button/ButtonComponent';
import Text from '../Text/TextComponent';
import { ReactSVG } from 'react-svg';
import __sortBy from 'lodash/sortBy';
import { dataResources } from '@portal-internet/core';
import Separator from '../Separator/SeparatorComponent';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

const DataSourceItem = ({ text, value }) => (
    <li className={styles.redlDataSourceItem}>
        <Text tag="span" weight="400" size="sm">{text}</Text>
        <span className={styles.redlDataSourceData}>
            <Text tag="span" weight="400" size="sm">{value}</Text>
        </span>
    </li>
);

export default function DataSourceComponent({ editableInfo, blocConfig }) {
    const { setShowRightSidePanel } = useRedl();
    const sourceList = __sortBy(Object.keys(editableInfo.sources || {}).map(s => ({
        name: s,
        url: editableInfo.sources[s]?.url
    })), ['name']);

    return (
        <div className={styles.redlDataSource}>
            {sourceList.map((s, index) =>
                <Fragment key={s.name}>
                    <div className={styles.redlDataSourceInnerLeft}>
                        <div className={styles.redlDataSourceTitle}>
                            <Text tag="span" weight="400" size="sm"
                                  transform="uppercase">{`Font de dades ${sourceList.length > 1 ? index + 1 : ''}`.trim()}</Text>
                            <div className={styles.redlDataSourceInnerRight}>
                                <Button variant="tertiary" size="sm"
                                        onClick={() => setShowRightSidePanel(prevState => ({
                                            ...prevState, size: 'xl', fontDeDades: {
                                                path: editableInfo.path,
                                                source: s,
                                                blocConfig
                                            }
                                        }))}>
                                    <ReactSVG src={basePath + '/_resources/REDL/icons/pencil.svg'} />
                                </Button>
                            </div>
                        </div>
                        <ul className={styles.redlDataSourceList}>
                            <DataSourceItem text="Nom:" value={s.name} />
                            <DataSourceItem text="URL:" value={s.url} />
                        </ul>
                    </div>
                    <Separator />
                </Fragment>
            )}
        </div>);
}
